import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { ProvisionItem } from '../../models/provisionitem';
import { Provision } from '../../models/provision';
import { SearchProvisionItemsPipe } from '../../pipes/searchprovisionitems/searchprovisionitems.pipe';
import { Subscription } from 'rxjs';
import { ProvisionService } from 'src/services/provision/provision.service';
import { ProvisionChange } from 'src/models/provisionchange';
import { StateService } from 'src/services/state/state.service';


@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    selector: 'conversion-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.css']
})


export class ConfigurationComponent implements OnInit, OnDestroy {
    @Input() id: string;

    constructor(private provisionService: ProvisionService, 
                private stateService: StateService) { }

    searchspecification = '';
    provision = new Provision();
    provisionPipeResult = new Array<ProvisionItem>();
    displayedProvision: ProvisionItem[] = [];
    readonly pageSize = 10;
    page = 1;
    searchProvisionPipe = new SearchProvisionItemsPipe();    
    subscriptions: Subscription[] = [];
    changes: Array<ProvisionChange> = new Array<ProvisionChange>();
    provisionloading : boolean;

    ngOnInit(): void {
        this.subscriptions.push(this.provisionService.getProvisionUpdates()
            .subscribe(provision => {
                if (this.provision !== provision) {
                    this.provision = provision;
                    this.getSortedProvision();
                }
            }))

        this.subscriptions.push(this.provisionService.getprovisionchangesUpdates()
            .subscribe(c => {
                if (c != null) {
                    this.changes = c;
                }
        }));

        this.subscriptions.push(this.stateService.getProvisionLoadingUpdate()
        .subscribe(data => {
            this.provisionloading = data;
        }));
    }

    getSortedProvision() {
        this.provisionPipeResult = this.searchProvisionPipe.transform(this.provision.Provision, this.searchspecification)
        this.showPage(1);
    }

    get pageCount(): number { return Math.max(1, Math.ceil(this.provisionPipeResult.length / this.pageSize)); }
    get firstVisible(): number { return this.provisionPipeResult.length ? (this.page - 1) * this.pageSize + 1 : 0; }
    get lastVisible(): number { return Math.min(this.page * this.pageSize, this.provisionPipeResult.length); }

    showPage(page: number): void {
        this.page = Math.max(1, Math.min(page, this.pageCount));
        this.displayedProvision = this.provisionPipeResult.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }

    trackProvisionItem(_index: number, item: ProvisionItem): string { return `${item.Type}:${item.Family}`; }

    selectExecution(currentexecution: ProvisionItem, newexecution: ProvisionItem) {
        let changeList = new Array<ProvisionChange>();
        const change = new ProvisionChange(
            currentexecution.Type,
            currentexecution.Family,
            currentexecution.FamilyDescription,
            currentexecution.Execution,
            currentexecution.ExecutionDescription,
            newexecution.Execution,
            newexecution.ExecutionDescription,
        );
        changeList.push(change);
        this.provisionService.insertChange(changeList);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
